// Generated by ReScript, PLEASE EDIT WITH CARE


function mounted() {
  var self = this ;
  var element = self.el;
  var id = element.id;
  if (id === "client-error" || id === "server-error") {
    return ;
  }
  var timer = setTimeout((function () {
          element.click();
        }), 5000);
  self.timer = timer;
}

function destroyed() {
  var self = this ;
  var timer = self.timer;
  if (!(timer == null)) {
    clearTimeout(timer);
    return ;
  }
  
}

var flashNotification = {
  mounted: mounted,
  destroyed: destroyed
};

export {
  mounted ,
  destroyed ,
  flashNotification ,
}
/* mounted Not a pure module */
